module.exports = __webpack_public_path__ + "static/media/404.ded69282.JPG";